<script setup lang="ts">
import type {IModalExpose} from "~/components/types";
import {defineExpose, withDefaults, defineProps} from "vue";
import Sprites from "~/components/icon/Sprites.vue";

const $props = withDefaults(defineProps<{
  width?: number
}>(), {
  width: 600
})

const isShow = ref(false);
function open() {
  isShow.value = true;
}
function close() {
  isShow.value = false;
}

defineExpose<IModalExpose>({
  open, close
})
</script>

<template>
  <teleport to="#gallery" v-if="isShow">
    <div class="modal custom-scroll">
      <div class="modal-content" :style="{ width: `${width}px` }">
        <a href="#" @click.prevent="close" class="close-gallery" aria-label="Закрыть окно"></a>
        <slot name="content"/>
      </div>

      <sprites>
        <symbol id="icon-slide-next" viewBox="0 0 43 43" fill="none">
          <rect width="43" height="43" rx="5" transform="matrix(-1 0 0 1 43 0)" fill="#5667FF"/>
          <path d="M18.5 14L26 21.5L18.5 29" stroke="white" stroke-width="2"/>
        </symbol>
      </sprites>
    </div>
  </teleport>
</template>

<style lang="scss">
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 222;
  backdrop-filter: blur(5px);
  background: rgba(0,0,0,.75);
  padding: 25px;

  .modal-content {
    width: 600px;
    padding: 30px;
    max-width: 100%;
    border-radius: var(--main-border-radius);
    background: #fff;
    color: $GRAY_TEXT_DARK;
    @include font-size(18px);
    --min-font-size: 16px;
    line-height: 1.5em;
    position: relative;
  }

  .close-gallery {
    display: block;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    position: absolute;
    right: -15px;
    top: -15px;
    z-index: 23;
    background: $RED;
    transition: all .25s ease;

    &:after,
    &:before {
      content: "";
      display: block;
      position: absolute;
      left: 20%;
      top: calc(50% - 2px);
      transform: rotate(45deg);
      width: 60%;
      height: 3px;
      background: #fff;
    }
    &:after {
      transform: rotate(-45deg);
    }
    &:hover {
      box-shadow: 0 0px 20px 0 rgba(193, 69, 56, 0.45);
    }
  }
}
</style>
